// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"styles-primaryButton-1tjLXY","pageDivider":"styles-pageDivider-649GwK","active":"styles-active-2dHb4y","spinner":"styles-spinner-1xXbQ5"};